import { Component, OnInit } from '@angular/core';
import { MeetingSchedulerStoreService } from '../data-providers/meeting-scheduler-store.service';

@Component({
  selector: 'meeting-scheduler-meeting-type-list-view',
  templateUrl: './meeting-type-list-view.component.html',
  styleUrls: ['./meeting-type-list-view.component.scss'],
  standalone: false,
})
export class MeetingTypeListViewComponent implements OnInit {
  selectedIndex = 0;
  constructor(private readonly meetingSchedulerStoreService: MeetingSchedulerStoreService) {}
  ngOnInit() {
    this.selectedIndex = this.meetingSchedulerStoreService.selectedTabEventTypeListView;
  }

  onTabChange(index) {
    this.meetingSchedulerStoreService.selectedTabEventTypeListView = index;
  }
}
